
































































import { Vue, Component } from 'vue-property-decorator'
import HeaderBar from '@/components/header-bar-noFixed/index.vue'

// 新流程引入的组件
import BaseInfo from './components/baseInfo.vue' // 第三步:填写信息
import Read from './components/read.vue' // 第一步:阅读合同
import Certification from './components/certification.vue' // 第二步:实名认证
import Info from './components/info.vue' // 第三步:填写信息
import Result from './components/result.vue' // 第四步:审核结果
import { CHECK_STATUS } from '@/constants/applyForm'
import SubmitTransition from '@/components/submit-transition/index.vue'
import { getCertifiStauts } from '@/services/apply'

@Component({
  components: {
    HeaderBar,
    BaseInfo,
    Read,
    Certification,
    Info,
    Result,
    SubmitTransition,
  },
})
export default class Apply extends Vue {
  currentStep: string = ''
  inBuffer: Boolean = false
  noVerifi: Boolean = false

  $toast: any

  CHECK_STATUS = CHECK_STATUS

  get userInfo() {
    return this.$store.state.userInfo
  }

  get userInfoInapp() {
    return this.$store.state.userInfoInapp
  }

  get checkStatus() {
    // if (this.userInfo.extInfo && !isNaN(this.userInfo.extInfo.settledStatus)) {
    //   return this.userInfo.extInfo.settledStatus
    // }
    // return this.CHECK_STATUS.NOT_APPLY

    if (this.userInfo && !isNaN(this.userInfo.accountState)) {
      // 判断入驻状态
      if (this.userInfo && this.userInfo.accountState != 0) {
        console.log('this.noVerifi', this.noVerifi)
        if (
          this.userInfo.accountType === 1 &&
          this.userInfo.accountState === 2
        ) {
          this.noVerifi = false // 通过实名认证: 是
        } else {
          this.noVerifi = true // 通过实名认证: 否
        }
        return this.userInfo.accountState
      }
      // 判断是否入驻分账剧品类
      if (this.userInfo && this.userInfo.partnerState === 2) {
        return this.CHECK_STATUS.ISPARTNER
      }
    }
    return this.CHECK_STATUS.NOT_APPLY
  }

  mounted() {
    // if (this.userInfo && !isNaN(this.userInfo.accountState)) {
    //   this.getCertiStatus()
    // }
    this.jumpStep()
  }

  goBack() {
    if (this.currentStep == 'read') {
      this.currentStep = 'baseInfo'
    } else {
      this.$router.back()
    }
  }
  async getCertiStatus() {
    const res = await getCertifiStauts({
      uuid: this.userInfoInapp.uuid,
    })
    if (res && res.code === 200) {
      if (res.data.verificationStatus === 0) {
        // 0:未通过实名认证，1:通过实名认证
        this.noVerifi = true
        // 0在缓冲日期内，1过了缓冲日期
        this.inBuffer = res.data.deadline === 0
      } else {
        this.noVerifi = false
      }
      this.jumpStep()
    }
  }

  jumpStep() {
    let checkStatus = this.userInfo.accountState
    console.log('checkStatus', checkStatus)
    console.log('this.noVerifi', this.noVerifi)
    // if (checkStatus === 4 || checkStatus === 2) {
    //   this.currentStep = 'info'
    // } else if (checkStatus === 1 && this.noVerifi) {
    //   // 已入驻 未实名
    //   this.currentStep = 'read'
    // } else if (checkStatus === 1 && (!this.noVerifi)) {
    //   // 已入驻 已实名
    //   this.currentStep = 'certification'
    // } else if (checkStatus === 0) {
    //   // 审核中
    //   this.currentStep = 'result'
    // } else {
    //   this.currentStep = 'read'
    // }

    // if (checkStatus === 4 || checkStatus === 3) {
    //   this.currentStep = 'info'
    // } else
    if (checkStatus === 2 && this.noVerifi) {
      // 已入驻 未实名
      this.currentStep = 'baseInfo'
    } else if (
      (checkStatus === 2 && !this.noVerifi) ||
      this.userInfo.accountType === 1 //填过邀请码，直接到实名认证页面
    ) {
      // 已入驻 已实名
      this.currentStep = 'certification'
    } else if (checkStatus === 1) {
      // 审核中
      this.currentStep = 'result'
    } else {
      this.currentStep = 'baseInfo'
    }
  }

  beforeMount() {
    // chrome
    document.body.scrollTop = 0
    // firefox
    document.documentElement.scrollTop = 0
  }
}
